import type { SxProps } from "@mui/material";
import { Box, styled } from "@mui/material";

export const column = {
  display: "flex",
  flexDirection: "column",
} as const satisfies SxProps;

export const Column = styled(Box)(column);

export const fill = {
  display: "flex",
  flex: 1,
  overflow: "auto",
} as const satisfies SxProps;

/** @public */
export const Fill = styled(Box)(fill);

export const row = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
} as const satisfies SxProps;

export const Row = styled(Box)(row);
